<template>
  <section class="section">
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="#28a745">mdi-file</v-icon>
          <h4>{{ $t("messages.general.showInfo") }}</h4>
        </div>
        <div class="card-body">
          <div style="color: #000 !importatnt">
            <div class="information-block">
              <div class="row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <div>{{ $t("messages.general.identity") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ studentCode }}</div>
                    </div>
                  </div>
                </div>
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <div>{{ $t("messages.general.fullname") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ displayName }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <div>{{ $t("messages.general.yearPlan") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ admitYear }}</div>
                    </div>
                  </div>
                </div>
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div
                      class="col no-margin-padding"
                      style="flex: 0 0 16em; white-space: nowrap;"
                    >
                      <div>{{ $t("messages.general.prevTerm") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ admitTerm }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <div>{{ $t("messages.general.educationLvl") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ currentLvl }}</div>
                    </div>
                  </div>
                </div>
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <div>{{ $t("messages.general.educationYear") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ currentStudentYear }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <div>{{ $t("messages.general.faculty") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ currentFaculty }}</div>
                    </div>
                  </div>
                </div>
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <div>{{ $t("messages.general.department") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ currentDepartment }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <div>{{ $t("messages.general.educationCourse") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        {{ currentProgramName }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 16em;">
                      <div>{{ $t("messages.general.yearRef") }}</div>
                    </div>
                    <div class="col no-margin-padding">
                      <div>{{ currentStudyPlanYear }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="color: #000">
            {{ $t("messages.chkClassByPlan.classByStudyPlan") }}
          </div>
          <v-divider></v-divider>
          <v-expansion-panels accordion :multiple="multiple" v-model="panels">
            <v-expansion-panel v-for="(item, index) in studyPlan" :key="index">
              <v-expansion-panel-header>
                {{ $t("messages.general.educationYear") }}
                {{ item.STUDENTYEAR }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  v-for="(itemContent, idxContent) in item.GROUPSEMESTER"
                  :key="idxContent"
                >
                  <div style="color: #000">
                    {{ $t("messages.general.semester") }}
                    {{ itemContent.SEMESTER }}
                  </div>
                  <div class="table-responsive">
                    <table class="table table-striped" id="table-epp1">
                      <thead>
                        <tr>
                          <th
                            class="text-center"
                            style="width: 40px !important"
                          >
                            {{ $t("messages.general.seqOrder") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.classId") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.className") }}
                          </th>
                          <th class="text-center">
                            {{ $t("messages.general.credit") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(itemTbl, idxTbl) in itemContent.STUDYPLAN"
                          :key="idxTbl"
                        >
                          <td
                            class="text-center"
                            style="width: 40px !important"
                          >
                            {{ idxTbl + 1 }}
                          </td>
                          <td class="text-center">{{ itemTbl.COURSECODE }}</td>
                          <td v-html="itemTbl.COURSENAME">
                            {{ itemTbl.COURSENAME }}
                          </td>
                          <td class="text-center" style="white-space: nowrap">
                            {{ itemTbl.COURSEUNIT }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            class="text-center"
                            style="width: 40px !important"
                          ></td>
                          <td class="text-center"></td>
                          <td class="text-center"></td>
                          <td class="text-right" style="white-space: nowrap;">
                            {{ $t("messages.general.total") }}
                            {{ itemContent.STUDYPLAN.length }}
                            {{ $t("messages.general.classCode") }}
                            {{ $t("messages.general.all") }}
                            {{ calculateCredit(itemContent.STUDYPLAN) }}
                            {{ $t("messages.general.credit") }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import AcademicProvider from "@/services/academic_provider";

const academicProvider = new AcademicProvider();

export default {
  name: "chkClassByPlan",
  data() {
    return {
      multiple: true,
      panels: [],
      studyPlan: []
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      studentInfo: "getStudentInfo",
      studentId: "getStudentId"
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
    currentUserId: function() {
      return _.isEmpty(this.studentInfo.data) ? this.userId : this.studentId;
    },
    currentProgramId: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.PROGRAMID
        : this.studentInfo.data.PROGRAMID;
    },
    currentStudyPlanId: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.STUDYPLANID
        : this.studentInfo.data.STUDYPLANID;
    },
    studentCode: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.USERCODE_TXT
        : this.studentInfo.data.STUDENTCODE;
    },
    displayName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.USERNAME
        : `${this.studentInfo.data.PREFIXNAME} ${this.studentInfo.data.STUDENTNAME} ${this.studentInfo.data.STUDENTSURNAME}`;
    },
    admitYear: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.ADMITACADYEAR
        : this.studentInfo.data.ADMITACADYEAR;
    },
    admitTerm: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.ADMITSEMESTER
        : this.studentInfo.data.ADMITSEMESTER;
    },
    currentLvl: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.LEVELNAME
        : this.studentInfo.data.LEVELNAME;
    },
    currentStudentYear: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.STUDENTYEAR
        : this.studentInfo.data.STUDENTYEAR;
    },
    currentFaculty: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.FACULTYNAME
        : this.studentInfo.data.FACULTYNAME;
    },
    currentDepartment: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.DEPARTMENTNAME
        : this.studentInfo.data.DEPARTMENTGROUPNAME;
    },
    currentProgramName: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.PROGRAMNAME
        : this.studentInfo.data.PROGRAMNAME;
    },
    currentStudyPlanYear: function() {
      return _.isEmpty(this.studentInfo.data)
        ? this.appInfo.data.STUDYPLANACADYEAR
        : this.studentInfo.data.STUDYPLANACADYEAR;
    }
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    async getStudyPlan() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          studentid: this.currentUserId,
          programid: this.currentProgramId,
          studyplanid: this.currentStudyPlanId,
          lang: this.currentLang
        }
      };
      const data = await academicProvider.getStudyPlan(params);
      if (data != undefined && data.length > 0) {
        data.forEach(d => {
          if (d.COURSENAME != undefined) {
            let temp = this.replaceNewLine(d.COURSENAME);
            temp = this.replaceTab(temp);
            d.COURSENAME = temp;
          }
        });
      }
      const gData = _.chain(data)
        .groupBy("STUDENTYEAR")
        .map((value, key) => ({ STUDENTYEAR: key, STUDYPLAN: value }))
        .value();
      gData.forEach(d => {
        const tmp = _.chain(d.STUDYPLAN)
          .groupBy("SEMESTER")
          .map((value, key) => ({ SEMESTER: key, STUDYPLAN: value }))
          .value();
        d.GROUPSEMESTER = tmp;
      });
      this.studyPlan = gData;
      this.togglePreLoader(false);
    },
    replaceNewLine(data) {
      return data.toString().replace(/\|/g, "<br />");
    },
    replaceTab(data) {
      return data.toString().replace(/<T>/g, "&emsp;");
    },
    calculateCredit(data) {
      let result = 0;
      data.forEach(d => {
        result += d.CREDITTOTAL;
      });
      return result;
    },
    getDefaultPanel() {
      if (this.studyPlan.length == 1) {
        this.panels.push(0);
      } else {
        let tempPanels = 0;
        const studentYear = _.isEmpty(this.studentInfo.data)
          ? this.appInfo.data.STUDENTYEAR
          : this.studentInfo.data.STUDENTYEAR;
        if (studentYear <= 4) {
          tempPanels = studentYear - 1;
          this.panels.push(studentYear - 1);
        } else {
          tempPanels = 3;
          this.panels.push(3);
        }
        if (this.studyPlan.length > 0 && this.studyPlan.length < tempPanels) {
          this.panels.push(this.studyPlan.length - 1);
        }
      }
    }
  },
  async mounted() {
    this.tokenHealthChk();
    await this.getStudyPlan();
    this.getDefaultPanel();
  },
  watch: {
    async currentLang() {
      await this.getStudyPlan();
      this.getDefaultPanel();
    }
  }
};
</script>
